import {login} from './login'

export const auth = {
  login,
}
